const recentPodcastBlock = () => {
    const setup = () => {
        const podcastPlaylist = document.querySelector('.podcast-playlist');
        
        // Early return if there's no podcast playlist element
        if (!podcastPlaylist) return;

        const podcastEpisodes = document.querySelectorAll('.podcast-episode');
        const playlistLinks = document.querySelectorAll('.podcast-playlist__link');
        const playlistThumbnails = document.querySelectorAll('.podcast-playlist__thumbnail');
    
        function switchEpisode(index, shouldFocus = true) {
            podcastEpisodes.forEach((episode, i) => {
                episode.classList.toggle('hidden', i !== index);
                episode.classList.toggle('block', i === index);
            });
    
            playlistThumbnails.forEach((thumbnail, i) => {
                thumbnail.classList.toggle('border-brand-600', i === index);
                thumbnail.classList.toggle('border-gray-600', i !== index);
            });
    
            if (shouldFocus) {
                const activeEpisode = podcastEpisodes[index];
                const listenNowLink = activeEpisode.querySelector('.btn');
                if (listenNowLink) {
                    setTimeout(() => {
                        listenNowLink.focus();
                    }, 50);
                }
            }
        }
    
        playlistLinks.forEach((link, index) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                switchEpisode(index);
            });
    
            link.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    switchEpisode(index);
                }
            });
        });
    
        // Initialize the first episode as visible without focusing on the button
        switchEpisode(0, false);
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
    } else {
        setup();
    }
};

const init = () => {
    recentPodcastBlock();
};

export default {
    init
};